import { BrandSubscriptionModel, unsubscribeFromBrandSubscription } from 'owa-brands-subscription';
import controlStrings from 'owa-strings/owa-common-strings';
import { confirm, ConfirmCustomizationOptions, DialogResponse } from 'owa-confirm-dialog';
import { format } from 'owa-strings';
import { ItemViewState } from 'owa-mail-reading-pane-store';
import { orchestrator } from 'satcheljs';
import strings from 'owa-strings/owa-mail-strings';
import unsubscribeEmailV2 from '../actions/unsubscribeEmailV2';
import removeInfoBarMessageInReadingPane from 'owa-info-bar/lib/actions/removeInfoBarMessage';

orchestrator(unsubscribeEmailV2, actionMessage => {
    confirm(
        strings.unsubscribeDialogTitleTextV2,
        format(strings.unsubscribeDialogSubTitleTextV2, actionMessage.message.From.Mailbox.Name),
        false /* resolevImmediately */,
        <ConfirmCustomizationOptions>{
            okText: controlStrings.okButton,
            cancelText: controlStrings.cancelButton,
        }
    ).then(async (response: DialogResponse) => {
        if (response === DialogResponse.ok) {
            unsubscribeWithoutConfirmDialog(actionMessage.cacheEntry, actionMessage.itemViewState);
        }
    });
});

function unsubscribeWithoutConfirmDialog(
    cacheEntry: BrandSubscriptionModel,
    itemViewState: ItemViewState
) {
    unsubscribeFromBrandSubscription(
        'ReadingPaneInfoBar',
        cacheEntry.smtpInfo.smtpIdentifier,
        cacheEntry.unsubscribeSilentUris,
        cacheEntry.unsubscribeHttpUris[0],
        () => {
            removeInfoBarMessageInReadingPane(itemViewState, 'unsubscribeInfoBar');
        }
    );
}
